export default {
  methods: {
    isSuperAdmin() {
      const permissions = JSON.parse(localStorage.getItem("userPermissions"));
      return permissions.includes("super-admin-access");
    },
    hasPermission(key) {
      const whiteList = ["home"];

      const permissions = JSON.parse(localStorage.getItem("userPermissions"));

      if (whiteList.includes(key)) {
        return true;
      }

      return permissions.includes(key);
    },
    checkPermission: (key = null) => {
      if (key === null) return false;
      const permissions = JSON.parse(localStorage.getItem("userPermissions"));
      const permissionsFilter = permissions.filter((p) => p === key);
      if (permissionsFilter.length === 0) {
        return false;
      }
      return true;
    },
  },
};
